var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010421",
    transform: "translate(0.232178 0.224609)",
    d: "M19.340397 22.324656C20.254364 23.225115 21.732271 23.225115 22.636517 22.324656L41.314526 3.9323199C42.228493 3.0318618 42.228493 1.5758017 41.314526 0.68492293C40.400555 -0.20595585 38.922649 -0.21553519 38.018406 0.68492293L21.00304 17.448771L3.9779539 0.67534363C3.0639858 -0.22511454 1.5860798 -0.22511454 0.68183482 0.67534363C-0.22241025 1.5758017 -0.2321333 3.0318618 0.68183482 3.9227405L19.340397 22.324656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewExpandIcon);
export default __webpack_public_path__ + "static/media/newExpandIcon.dcf4615c08373cabd2fa6cc2124a44bf.svg";
export { ForwardRef as ReactComponent };